import { hamburger } from "../svg-images/icons";
import { Link } from "react-router";
import MobileMenu from "./mobile-menu";
import PropTypes from "prop-types";
import React, { Component } from "react";

class SmallNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
    };
  }

  toggleMenu = () => {
    this.setState({ showMenu: !this.state.showMenu });
  };

  render() {
    const entity = this.props.entity;
    return (
      <div className="small-nav hidden visible-sm visible-xs">
        <div>
          <div className="hamburger-menu" onClick={this.toggleMenu}>
            {hamburger}
          </div>
          <div className="agent-info">
            <h4 className={!entity.tagline ? "name-only" : ""}>
              <Link to="/">{entity.displayName}</Link>
            </h4>
            <div className="tagline">{entity.tagline}</div>
          </div>
        </div>
        <div className={this.state.showMenu ? "showMenu" : ""}>
          <MobileMenu
            entity={entity}
            items={this.props.items}
            toggleMenu={this.toggleMenu}
          />
        </div>
      </div>
    );
  }
}

SmallNav.propTypes = {
  items: PropTypes.array.isRequired,
  entity: PropTypes.object.isRequired,
};

export default SmallNav;



// WEBPACK FOOTER //
// ./src/components/shared/navbar/small-nav.js